import { Component } from '@angular/core';

@Component({
  selector: 'fl-media-object-content',
  template: `<ng-content></ng-content>`,
})
export class MediaObjectContentComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/media-object/media-object-content.component.ts